import React, { useState, useEffect } from "react";
import { Form, Divider } from "antd";
import "./LangId.css";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton/PrimaryButton";
import Selector from "../../../../components/Selector/Selector";
import Spinner from "../../../../components/Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import centralApi from "../../../../services/centralApi";
import { t } from "i18next";
import useMessage from "hooks/useMessage";
import { fetchTemplateMetaData } from "redux/features/templates_/variantsSlice";
import { getToken } from "redux/features/app/authTokenSlice";
import { API_ENDPOINTS } from "utils/constants";
import { useForm } from "antd/es/form/Form";

const LangId: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const dispatch: any = useDispatch();
  const { showError, showSuccess } = useMessage();
  const [form] = useForm();

  const loginUser = useSelector((state: any) => state.loginUser);
  const activeApp = useSelector((state: any) => state.activeApp);
  const languageMetaData = useSelector(
    (state: any) => state.templateMetaData.data
  );

  const appId = activeApp?.appId;
  const api_key = loginUser?.data?.api_key;
  const initialLangId = useSelector(
    (state: any) => state.featuresSetting?.data[0].lang_id || {}
  );
  const languages = languageMetaData?.varaints || [];

  const initialValue =
  languages.find((lang: any) => lang.lang_id === initialLangId) || null;
  // const [selectedLang, setSelectedLang] = useState<any>(initialValue?.name);
  const [selectedLang, setSelectedLang] = useState<any>(initialValue);

  useEffect(() => {
    if (appId && api_key) {
      dispatch(fetchTemplateMetaData({ app_id: appId, api_key, args: {} }));
    }
  }, [appId, api_key, dispatch]);

  const onFormSubmit = async () => {
    if (!selectedLang) {
      showError(t("pleaseSelectLanguageLabel"));
      return;
    }
    const authToken = await dispatch(getToken()).unwrap();

    const payload = {
      args: {
        lang_id: selectedLang.lang_id, //
      },
      app_id: appId,
      api_key,
      authToken,
    };

    try {
      setLoading(true);
      await centralApi(
        "POST",
        API_ENDPOINTS.SAVE_APP_SETTING_URL,
        payload,
        null
      );

      showSuccess(t("sucessfullySavedLabel"));
    } catch (error) {
      showError(t("somethingWrongLabel"));
    } finally {
      setLoading(false);
    }
  };
// after languages and initialValue are defined
useEffect(() => {
  if (initialValue) {
    setSelectedLang(initialValue); // store full object
    form.setFieldsValue({
      language: JSON.stringify(initialValue),
    });
  }
}, [initialValue, form]);


  return (
    <div className="lang-id-setting-container">
      <div className="mt-4 mb-4">
        <h6 className="lang-id-setting-container-heading">
          {t("defaultLanguageLabel")}
        </h6>
        <Divider className="lang-id-setting-custom-divider" />

        <div className="col-sm-8 mt-4 align-items-center lang-id-setting-form">
          {loading ? (
            <Spinner />
          ) : (
            <Form layout="horizontal" form={form}
            onFinish={onFormSubmit}>
              <Form.Item
                label={t("selectLanguageLabel")}
              
                initialValue={selectedLang ? JSON.stringify(selectedLang) : undefined}
                name="language"
              >
                <Selector
                  className="lang-id-selector-full"
                  options={languages.map((lang: any) => ({
                    label: lang.name,
                    value: JSON.stringify(lang),
                  }))}
                  value={selectedLang ? JSON.stringify(selectedLang) : undefined}
                  placeholder={t("languageLabel")}
                  onChange={(jsonData) => {
                    const lang = JSON.parse(jsonData);
                    setSelectedLang(lang);
                  }}
                />
              </Form.Item>

              <PrimaryButton
                size="middle"
                type="primary"
                htmlType="submit"
                className="lang-id-btn-save"
              >
                {t("saveLabel")}
              </PrimaryButton>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default LangId;
